import z from "zod";

import { safeAttrValues } from "../attribute/safeAttrValues";
import { zSafeDataMap } from "../attribute/ZAttrValue";
import { ZSpecification } from "../specification";
import { makeAttrMetaMap } from "../specification/makeAttrMetaMap";
import { ZCatalogRecord, zCatalogRecord } from "./ZCatalogRecord";

export const zCatalogRecordSafe = zCatalogRecord.omit({ data: true }).and(
  z.object({
    data: zSafeDataMap,
  }),
);

export type ZCatalogRecordSafe = z.infer<typeof zCatalogRecordSafe>;

export const makeCatalogRecordSafe = (
  record: ZCatalogRecord,
  schemes: ZSpecification[],
): ZCatalogRecordSafe => {
  const { data: unsafeData, ...rest } = record;
  const safeData: ZCatalogRecordSafe["data"] = {};
  schemes.forEach((scheme) => {
    const unsafePart = unsafeData?.[scheme.name];
    if (unsafePart) {
      const metaMap = makeAttrMetaMap(scheme);
      safeData[scheme.name] = safeAttrValues(unsafePart, metaMap);
    }
  });
  return {
    ...rest,
    data: safeData,
  };
};
